import { Reveal } from "./Reveal";

const PASTURE =
  "https://images.unsplash.com/photo-1558030006-450675393462?q=85&w=1200&auto=format&fit=crop";

export const About = () => (
  <section id="ranch" className="py-24 lg:py-32 bg-white border-y border-linen" data-testid="about-section">
    <div className="max-w-7xl mx-auto px-6 lg:px-10 grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center">
      <Reveal className="lg:col-span-5">
        <div className="relative">
          <div className="absolute -top-4 -left-4 w-full h-full rounded-2xl border-2 border-clay/30" />
          <img
            src={PASTURE}
            alt="Sliced grilled beef from a Waters & Field share"
            className="relative rounded-2xl w-full aspect-[4/5] object-cover"
            data-testid="about-portrait"
          />
        </div>
      </Reveal>
      <div className="lg:col-span-7">
        <Reveal>
          <p className="text-xs tracking-[0.25em] uppercase font-bold text-clay mb-4">Who We Are</p>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl tracking-tight font-medium leading-tight">
            Farm to table, the way it should be.
          </h2>
        </Reveal>
        <Reveal delay={0.12}>
          <p className="text-moss text-base leading-relaxed mt-8 max-w-2xl">
            Our Angus cattle are raised and finished by a fourth-generation farmer in Palatka,
            Florida. No feedlots, no hormones, no routine antibiotics, no mystery meat — ever.
          </p>
          <p className="text-moss text-base leading-relaxed mt-5 max-w-2xl">
            You buy a share of the live animal, and North Florida Custom Meats — our licensed
            butcher — does the harvest, dry-aging, cutting, and wrapping. All processing fees
            are included in your price, so everything stays simple and by the book. When you
            reserve, you get our phone number and a straight answer to every question.
          </p>
        </Reveal>
        <Reveal delay={0.2} className="flex flex-wrap gap-x-12 gap-y-6 mt-10">
          {[
            ["4th", "generation farmer"],
            ["0", "feedlots, ever"],
            ["All", "fees included"],
          ].map(([stat, label]) => (            <div key={label} data-testid={`about-stat-${label.split(" ")[0].replace(/\W/g, "")}`}>
              <div className="font-display text-4xl font-medium text-forest">{stat}</div>
              <div className="text-sm text-moss mt-1">{label}</div>
            </div>
          ))}
        </Reveal>
      </div>
    </div>
  </section>
);
